import { ChangeDetectorRef, Component, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonModule, JsonPipe } from '@angular/common';
import { AccelerometerService } from '../services/navigator.service';

@Component({
  selector: 'app-accelerometer',
  standalone: true,
  //pipes: [JsonPipe],
  imports: [CommonModule,JsonPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<p>Current Acceleration: {{ acceleration | json }}</p>`
})
export class AccelerometerComponent implements OnInit, OnDestroy {
  private accelerometerService = inject(AccelerometerService);
  private cdr = inject(ChangeDetectorRef);

  acceleration: DeviceMotionEventAcceleration = { x: 0, y: 0, z: 0 };
  subscription!: Subscription;

  ngOnInit() {
    this.subscription = this.accelerometerService.getAcceleration().subscribe(
      (acceleration) => {
        this.acceleration = acceleration;
        this.cdr.markForCheck();
      }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
